import * as constants from '../constants';
import type { Action } from '../state-types';
import type { AccountState } from '../state-types/account';

const initialState: AccountState = {
  failedAccounts: new Map(),
  accountsSyncing: [],
  linkedAccounts: [],
  initialPollingStatus: {
    pollingTimeoutId: null,
    timesPolled: null,
  },
};

export function update(state = initialState, action: Action): AccountState {
  switch (action.type) {
    case constants.SET_ACCOUNTS_SYNCING:
      return {
        ...state,
        accountsSyncing: action.ids,
      };
    case constants.ACCOUNT_SYNC_STATUS: {
      const failedAccounts = new Map(state.failedAccounts);
      if (action.failed) {
        failedAccounts.set(action.id, {
          type: action.errorType,
          code: action.errorCode,
        });
      } else {
        failedAccounts.delete(action.id);
      }

      return { ...state, failedAccounts };
    }
    case constants.SET_LINKED_ACCOUNTS:
      return {
        ...state,
        linkedAccounts: action.linkedAccounts,
      };
    case constants.UPDATE_LINKED_ACCOUNT:
      const newLinkedAccounts = [];
      for (const linkedAccount of state.linkedAccounts) {
        if (linkedAccount.account_id === action.accountId) {
          newLinkedAccounts.push({
            ...linkedAccount,
            ...action.linkedAccount,
          });
        } else {
          newLinkedAccounts.push({
            ...linkedAccount,
          });
        }
      }
      return {
        ...state,
        linkedAccounts: newLinkedAccounts,
      };
    case constants.SET_INITIAL_POLLING_STATUS:
      return {
        ...state,
        initialPollingStatus: {
          pollingTimeoutId:
            action.pollingTimeoutId === undefined
              ? state.initialPollingStatus.pollingTimeoutId
              : action.pollingTimeoutId,
          timesPolled:
            action.timesPolled === undefined
              ? state.initialPollingStatus.timesPolled
              : action.timesPolled,
        },
      };
    default:
  }
  return state;
}
